



































































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    geoJsonToTableFormat
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import Combobox from '../../core/components/Combobox.vue';
import InputFile from '../../core/components/InputFile.vue';
import Button from '../../core/components/Button.vue';
import { MsgBox, PlusEyeButtons, Breadcrums, CloseConfirmationModal } from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        PlusEyeButtons,
        Breadcrums,
        CloseConfirmationModal,
        InputFile,
        Button
    }
})
export default class ModalGetNamesFromGeojson extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() sowingId: number;
    columnsList: Array<object> = [];
    pendingRequest: boolean = false;
    description: string = '';
    modalTitle: string = 'Levantar nombres desde geojson';

    //select options
    columnSelected: any | null = null;
    fileSelected: any = [];
    geoJsonFile: any = [];
    geoJsonFormData: any = [];
    geoJsonLoaded: boolean = false;
    fileHasColumnName: boolean = false;

    //select reset value
    columnRV: boolean = false;

    //methods
    mounted() {
        this.handleListenKey(true);
    }

    uploadedFile(file) {
        this.fileSelected = file;
    }

    clearGeojsonFile() {
        this.geoJsonFormData = [];
        this.geoJsonLoaded = false;
    }

    uploadFile() {
        this.columnsList = [];
        this.geoJsonLoaded = false;
        let reader = new FileReader();
        let self = this;
        this.geoJsonFormData = this.fileSelected[0];
        reader.readAsText(this.fileSelected[0]);
        reader.onload = (e: any) => {
            self.geoJsonLoaded = true;
            let lines = e.target.result;
            var newArr = JSON.parse(lines);
            //  self.geoJsonLoaded = true;
            let items = geoJsonToTableFormat(newArr);
            self.columnsList = items['headers'];
            if (self.columnsList.length > 0) {
                self.columnsList = self.columnsList.sort(sortObjectByPropertyName('value'));
                self.checkIfFileHasNameColumn();
            } else {
                self.fileHasColumnName = false;
            }

            if (self.columnsList.length == 1) {
                self.updateColumnSelected(self.columnsList[0]);
            }
        };
    }

    checkIfFileHasNameColumn() {
        let indexColumnName = this.columnsList.findIndex(item => item['value'] === 'name');
        if (indexColumnName !== -1) {
            this.fileHasColumnName = true;
        } else {
            this.fileHasColumnName = false;
        }
    }

    matchedIndexInArray(arr, id) {
        let optionIndex = arr.findIndex(item => item['id'] == id);
        return optionIndex;
    }

    updateColumnSelected(option) {
        this.columnSelected = option;
    }

    updateColumnResetValue(value) {
        this.columnRV = value;
    }

    closeModal() {
        this.$emit('close-modal', false);
        this.handleListenKey(false);
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    triggerSubmit() {
        let self = this;
        this.pendingRequest = true;
        let configuration = this.getData();
        self.scrollToTopOfModal();
        this.showLoadingDialog('Procesando...');

        InsuranceServices.uploadSowingInsuranceGeojson(self.sowingId, configuration)
            .then(response => {
                self.showSuccessLoadingDialog(response.data);
            })
            .catch(err => {
                self.handleCatchResponse(err, 'Ocurrio un error');
            });
    }

    scrollToTopOfModal() {
        $('.dialog-slot').scrollTop(0);
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response){
        let self = this;
        this.$_successLoadingDialog({
            response: response
        });
        setTimeout(() => {
            self.reloadFarmingDetail();
            this.closeModal();
        }, 1000);
    }
    handleCatchResponse(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }
    reloadFarmingDetail() {
        this.$emit('update-farming-detail');
    }

    getData() {
        let form_data = new FormData();
        form_data.append('file', this.geoJsonFormData);
        form_data.append('name_column', this.columnSelected['value']);

        return form_data;
    }

    get checkIfFormIsValid() {
        if (this.geoJsonFormData.length == 0) {
            return false;
        }

        if (this.columnSelected == null) {
            return false;
        }

        return true;
    }

    
    getFinalizationValue(finalization) {
        if (finalization !== null) {
            if (finalization['id'] !== -1) {
                return finalization['id'];
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    getInitializationValue(initialization) {
        if (initialization !== null) {
            if (initialization['id'] !== -1) {
                return initialization;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }
}
